<template>
  <img :src="src" :alt="model" class="device-image" @click="view" />
</template>

<script>
export default {
  props: {
    model: {
      type: String,
      required: true
    }
  },

  computed: {
    src() {
      return encodeURI(
        "https://device-finder.mplus.mn/api/images/" + this.model
      );
    }
  },

  methods: {
    view() {
      this.$buefy.modal.open({
        component: {
          template: `
                      <div style="display:flex; align-items: center; justify-content: center;">
                          <img src="${this.src}" alt="" />
                      </div>
                        `
        }
      });
    }
  }
};
</script>

<style>
.device-image {
  cursor: zoom-in;
}
</style>
